import { DownloadFromAppStoreLink, Stars } from '~/components/DownloadAppBlock';
import Tracked from '~/components/Tracked';
import useEnv from '~/hooks/useEnv';
import useRegion from '~/hooks/useRegion';

const APPS_FLYER_LINK = 'https://thesolesupplier.onelink.me/BPkz/3vndai6u';

export default function DownloadAppBanner({
  className
}: {
  className?: string;
}) {
  const region = useRegion();
  if (region.code !== 'GB') return null;

  return (
    <div
      className={`my-4 mt-20 flex h-[460px] flex-col items-center justify-center gap-2 bg-dark-mode-black text-white sm:h-[299px] sm:flex-row md:gap-10 ${className}`}
    >
      <PhoneImage />
      <div className="flex gap-6 px-3">
        <div className="flex flex-col gap-4">
          <TitleAndSubtitle />
          <div className="mb-12 flex items-center gap-4 lg:mb-0">
            <DownloadFromAppStoreLink
              href={APPS_FLYER_LINK}
              pagePosition="Banner"
            />
            <Tracked.ExternalLink
              name="DOWNLOAD_THE_APP"
              pagePosition="Banner"
              variant="forest"
              className="w-3/5 text-sm font-bold lg:hidden"
              href={APPS_FLYER_LINK}
              target="_blank"
            >
              Download now
            </Tracked.ExternalLink>
            <div className="hidden lg:block">
              <StarsAndRatings />
            </div>
          </div>
        </div>
        <QrCode />
      </div>
    </div>
  );
}

function PhoneImage() {
  return (
    <div className="mb-[-8px] sm:mb-[33px]">
      <img
        src="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/app_release_notification.png"
        alt="iPhone"
        className="h-[288px] w-auto sm:h-[332px]"
      />
    </div>
  );
}

function TitleAndSubtitle() {
  return (
    <div className="flex flex-col gap-2 bg-black p-4">
      <p className="text-3xl text-golden-syrup lg:text-4xl">
        Tired of missing drops?
      </p>
      <div className="flex items-end justify-between">
        <p className="text-3xl text-white lg:text-4xl">Get the app.</p>
        <div className="block lg:hidden">
          <StarsAndRatings />
        </div>
      </div>
    </div>
  );
}

function StarsAndRatings() {
  const env = useEnv();

  return (
    <div className="flex items-center gap-2">
      <Stars />
      <p>{env.APP_RATING}</p>
      <div className="hidden gap-2 lg:flex">
        <span className="text-sm text-grey-read">|</span>
        <p className="whitespace-nowrap text-sm text-grey-read">
          {env.APP_NUM_OF_RATINGS} ratings
        </p>
      </div>
    </div>
  );
}

function QrCode() {
  return (
    <div className="hidden flex-col gap-2 lg:flex">
      <p className="text-base -tracking-tight text-white">Scan to install</p>
      <img
        src="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/download_app_plp_qr_code.png"
        alt="QR code"
        className="size-24"
      />
    </div>
  );
}
